module.exports = __webpack_public_path__ + "img/logo.de4987ad.png";